export default __webpack_public_path__ + "static/media/my-technocity.d31b5059.png";